import { call, put, select } from "redux-saga/effects"

import userApi from "../../../api/user"
import {
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  FETCH_LUCKY_DRAW_USER_FAILURE,
  FETCH_LUCKY_DRAW_USER_SUCCESS,
  FETCH_AWARD_USER_SUCCESS,
  FETCH_AWARD_USER_FAILURE,
  GET_PRODUCT_LIST_FAILURE,
  GET_PRODUCT_LIST_SUCCESS,
} from "../../types/user"

// Helper function to get auth token
const getAuthToken = state => state.auth.token

// Worker Sagas
export function* fetchUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call([userApi, "fetchUser"], token, action.payload)
    if (response.error) {
      yield put({ type: FETCH_USER_FAILURE, payload: response.error })
    } else {
      yield put({
        type: FETCH_USER_SUCCESS,
        payload: response.data.users || response,
      })
    }
  } catch (error) {
    yield put({ type: FETCH_USER_FAILURE, payload: error.message })
  }
}

export function* createUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call([userApi, "createUser"], token, action.payload)

    if (response.error) {
      yield put({ type: CREATE_USER_FAILURE, payload: response.error })
    } else {
      yield put({
        type: CREATE_USER_SUCCESS,
        payload: response.data || response,
      })
    }
  } catch (error) {
    yield put({ type: CREATE_USER_FAILURE, payload: error.message })
  }
}

export function* updateUserWorker(action) {
  try {
    const response = yield userApi.updateUser(
      action.payload.userData,
      action.payload.token
    )
    console.log("updateUserWorker response:", response)

    if (response.status === 200) {
      yield put({
        type: UPDATE_USER_SUCCESS,
        payload: {
          user: response.data.userData.user,
          // token: response.data.userData.user.token,
          dashboard_redirection_type:
            response.data.userData.user.dashboard_redirection_type,
          pvs_cards: response.data.userData.pvs_cards,
        },
      })
    } else {
      yield put({ type: UPDATE_USER_FAILURE, payload: response.error })
    }
  } catch (error) {
    yield put({
      type: UPDATE_USER_FAILURE,
      payload: { message: error.message },
    })
  }
}

export function* getProductListWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield userApi.getProductList(
      action.payload.pageData,
      token
    )
    console.log("getProductListWorker response:", response)

    if (response.status === 200) {
      yield put({
        type: GET_PRODUCT_LIST_SUCCESS,
        payload: { products: response.data.products },
      })
    } else {
      yield put({ type: GET_PRODUCT_LIST_FAILURE, payload: response.error })
    }
  } catch (error) {
    yield put({ type: GET_PRODUCT_LIST_FAILURE, payload: error.message })
  }
}

export function* deleteUserWorker(action) {
  try {
    const categoryId = action.payload
    const token = yield select(getAuthToken)
    const response = yield call([userApi, "deleteUser"], token, categoryId)

    if (response.error) {
      yield put({ type: DELETE_USER_FAILURE, payload: response.error })
    } else {
      yield put({ type: DELETE_USER_SUCCESS, payload: categoryId })
    }
  } catch (error) {
    yield put({ type: DELETE_USER_FAILURE, payload: error.message })
  }
}

export function* fetchUserDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [userApi, "getUserDetails"],
      token,
      action.payload
    )

    if (response.error) {
      yield put({ type: FETCH_USER_DETAILS_FAILURE, payload: response.error })
    } else {
      yield put({
        type: FETCH_USER_DETAILS_SUCCESS,
        payload: response.data.user || response,
      })
    }
  } catch (error) {
    yield put({ type: FETCH_USER_DETAILS_FAILURE, payload: error.message })
  }
}

export function* fetchAwardUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [userApi, "getAwardUser"],
      token,
      action.payload
    )

    if (response.error) {
      yield put({ type: FETCH_AWARD_USER_FAILURE, payload: response.error })
    } else {
      yield put({
        type: FETCH_AWARD_USER_SUCCESS,
        payload: response.data.awards || response,
      })
    }
  } catch (error) {
    yield put({ type: FETCH_AWARD_USER_FAILURE, payload: error.message })
  }
}

export function* fetchLuckyDrawUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [userApi, "getLuckyDrawUser"],
      token,
      action.payload
    )

    if (response.error) {
      yield put({
        type: FETCH_LUCKY_DRAW_USER_FAILURE,
        payload: response.error,
      })
    } else {
      yield put({
        type: FETCH_LUCKY_DRAW_USER_SUCCESS,
        payload: response.data.luckyDraw || response,
      })
    }
  } catch (error) {
    yield put({ type: FETCH_LUCKY_DRAW_USER_FAILURE, payload: error.message })
  }
}
